import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0aa5ab42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-auto" }
const _hoisted_2 = { class: "row overflow-hidden" }
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = { class: "relative pt-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "primary w-full absolute z-10 cursor-pointer opacity-0 h-16 left-0 top-1 bg-white",
  id: "chck3",
  type: "checkbox"
}, null, -1))
const _hoisted_6 = {
  class: "flex justify-between items-center cursor-pointer select-none tab-label bg-white rounded-lg",
  for: "chck3"
}
const _hoisted_7 = { class: "elements grid grid-cols-6 w-full pt-1 pb-1 text-left self-center bg-primary-50 items-center" }
const _hoisted_8 = {
  key: 0,
  class: "col-span-2"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "col-span-2"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "font-bold" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "animate-pulse bg-primary-100 w-60"
}
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = {
  key: 0,
  class: "clocking-in-date"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 2,
  class: "dropdown-section flex test m-auto bg-white rounded p-2"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-bold" }, "Vedi dettagli", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  "data-reactid": "266",
  fill: "none",
  height: "24",
  stroke: "#606F7B",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewbox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "6 9 12 15 18 9" })
], -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 0,
  class: "tab-content"
}
const _hoisted_28 = { class: "relative pl-5 pb-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pt-4 text-left font-bold" }, "Note:", -1))
const _hoisted_30 = { class: "text-grey-darkest text-left notes pt-2" }
const _hoisted_31 = {
  key: 1,
  class: "tab-content"
}
const _hoisted_32 = { class: "relative pl-5 pb-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pt-4 text-left font-bold" }, "Materiali richiesti:", -1))
const _hoisted_34 = { class: "text-grey-darkest text-left notes pt-2" }
const _hoisted_35 = {
  key: 2,
  class: "tab-content"
}
const _hoisted_36 = { class: "relative pl-5 pb-2" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pt-4 text-left font-bold" }, "Ore di viaggio:", -1))
const _hoisted_38 = { class: "text-grey-darkest text-left notes pt-2" }
const _hoisted_39 = {
  key: 3,
  class: "tab-content"
}
const _hoisted_40 = { class: "relative pl-5 pb-2" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pt-4 text-left font-bold" }, "Timbratura eseguita da:", -1))
const _hoisted_42 = { class: "text-grey-darkest text-left notes pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("header", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.scope == _ctx.ClockingInScope.workingSite)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_8, [
                    (_ctx.modelValue.userName && _ctx.modelValue.userSurname)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.modelValue.userName) + " " + _toDisplayString(_ctx.modelValue.userSurname), 1),
                          (_ctx.modelValue.createdByUserId != undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, " (da terzi)"))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.scope == _ctx.ClockingInScope.user)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_12, [
                    (_ctx.modelValue.workingSiteId != undefined && _ctx.workingSiteName != '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.workingSiteName), 1),
                          (_ctx.modelValue.createdByUserId != undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, " (da terzi)"))
                            : _createCommentVNode("", true)
                        ]))
                      : (_ctx.modelValue.workingSiteId != undefined)
                        ? (_openBlock(), _createElementBlock("input", _hoisted_16))
                        : (_openBlock(), _createElementBlock("span", _hoisted_17, "-"))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("h3", null, [
                (_ctx.modelValue.isClockingOut == undefined && _ctx.modelValue.timing == undefined)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, "-"))
                  : (_ctx.modelValue.timing != undefined)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "In viaggio"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.modelValue.isClockingOut ? 'Uscita' : 'Entrata'), 1))
              ]),
              _createElementVNode("h3", null, [
                (_ctx.modelValue.createdTs)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.moment.unix(_ctx.modelValue.createdTs).format("DD/MM/YYYY")), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("h3", null, [
                (_ctx.modelValue.createdTs)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.moment.unix(_ctx.modelValue.createdTs).format("HH:mm")), 1))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.modelValue.notes && _ctx.modelValue.notes.length > 0 || _ctx.modelValue.ppe && _ctx.modelValue.ppe.length > 0 || _ctx.modelValue.timing != undefined || _ctx.modelValue.createdByUserId != undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.modelValue.notes && _ctx.modelValue.notes.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue.notes, (note) => {
                    return (_openBlock(), _createElementBlock("p", _hoisted_30, "- " + _toDisplayString(note), 1))
                  }), 256))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.modelValue.ppe && _ctx.modelValue.ppe.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue.ppe, (ppe) => {
                    return (_openBlock(), _createElementBlock("p", _hoisted_34, "- " + _toDisplayString(ppe), 1))
                  }), 256))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.modelValue.timing != undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("p", _hoisted_38, "- " + _toDisplayString(_ctx.humanizedClockingInTiming(_ctx.modelValue.timing)), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.modelValue.createdByUserId != undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("p", _hoisted_42, "- " + _toDisplayString(_ctx.modelValue.createdByUserName) + " " + _toDisplayString(_ctx.modelValue.createdByUserSurname), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}